/* Krudo PickEasy cart integration.

   Problem 1 — Picker vanishes on cart update:
     cart.js does `elementToReplace.innerHTML = ...` on #CartDrawer-Body
     (and on the main-cart section on the cart page) every time the cart
     changes. That wipes PickEasy's #order-slots / #order-slots-option /
     #order-slots-cart-attributes nodes. PickEasy does not always re-inject.
     Fix: hold live references to the injected nodes. When the body is
     replaced and the picker is missing from the new form, re-attach the
     cached (detached) nodes — same DOM elements, so their current state
     (selected fulfillment option, picked date/time) survives untouched.

   Problem 2 — Checkout fires with no fulfillment data:
     Block the Checkout button until the user has picked a date/time.
     Re-evaluate on every relevant input and every cart re-render.

   NOT this file's job — which method is selected. mode-switch.js writes
   attributes["Order Fulfillment Type"] when the shopping mode changes, before
   the reload, and PickEasy reads that back on init and renders only the cards
   that apply (one in nationwide, two in local). An earlier version of this file
   tried to enforce the selection from here — tagging cards, hiding them by
   mode, clicking one — all of which turned out to be unnecessary once the
   attribute was set, and two of which caused live incidents. Don't reintroduce
   it: if the wrong method is selected, fix the cart attribute, not the DOM. */
(function () {
  if (window.KrudoPickEasyGate) return;
  window.KrudoPickEasyGate = true;

  const REQUIRED_MSG = 'Please select a date and time before checking out.';

  /* Cached PickEasy node references. They stay valid even after the
     form is re-rendered, because innerHTML replacement only detaches
     the children — it doesn't destroy the JS-held references. */
  const cache = {
    drawer: { slots: null, option: null, attrs: null },
    main:   { slots: null, option: null, attrs: null },
  };

  function captureFrom(form, slot) {
    if (!form) return;
    const slots  = form.querySelector('#order-slots');
    const option = form.querySelector('#order-slots-option');
    const attrs  = form.querySelector('#order-slots-cart-attributes');
    if (slots)  slot.slots  = slots;
    if (option) slot.option = option;
    if (attrs)  slot.attrs  = attrs;
  }

  let prevHadItems = false;
  function captureAll() {
    const hasItems = cartHasItems();
    /* When the cart transitions to empty, throw away the cache so the
       next add-to-cart doesn't restore a stale fulfillment selection
       from a previous shopping session. */
    if (prevHadItems && !hasItems) {
      cache.drawer = { slots: null, option: null, attrs: null };
      cache.main   = { slots: null, option: null, attrs: null };
    }
    prevHadItems = hasItems;
    if (!hasItems) return;
    captureFrom(document.getElementById('CartDrawer-Form'), cache.drawer);
    /* On the cart page, PickEasy injects into the main cart form. */
    captureFrom(document.querySelector('cart-items form, #main-cart-items form, form[action*="/cart"]'), cache.main);
  }

  function restoreInto(form, slot) {
    if (!form || !slot.slots) return false;
    if (form.querySelector('#order-slots')) return false; /* Already present (e.g. PickEasy re-injected). */

    /* Where to re-attach the picker. On the cart PAGE the form also wraps the
       order summary + checkout button, so appending to the end of the form
       drops the picker BELOW checkout after a quantity edit. The correct spot
       is right ABOVE the checkout button (after the order summary), so anchor
       to the checkout button's section. In the cart DRAWER the checkout lives
       in a separate form, so there's no anchor here and we append to the end
       of the fulfillment form (correct). */
    var checkoutBtn = form.querySelector('[name="checkout"]');
    var checkoutBlock = checkoutBtn ? (checkoutBtn.closest('.cart__sidebar-section') || checkoutBtn) : null;
    var target, before;
    if (checkoutBlock && checkoutBlock.parentNode) {
      target = checkoutBlock.parentNode;
      before = checkoutBlock;
    } else {
      target = form;
      before = null;
    }

    function place(node) {
      if (!node || target.contains(node)) return;
      if (before) target.insertBefore(node, before);
      else target.appendChild(node);
    }

    /* Re-attach in the same order PickEasy uses: option, slots, cart-attributes. */
    place(slot.option);
    place(slot.slots);
    place(slot.attrs);
    return true;
  }

  function restoreAll() {
    let restored = false;
    restored = restoreInto(document.getElementById('CartDrawer-Form'), cache.drawer) || restored;
    restored = restoreInto(document.querySelector('cart-items form, #main-cart-items form, form[action*="/cart"]'), cache.main) || restored;
    return restored;
  }

  /* ---------- Never leave a hidden card selected ----------

     PickEasy always initialises on Local Delivery. In nationwide the CSS hides
     that card, but hiding does not deselect it — so the shopper can end up with
     an invisible card active, looking at Local Delivery's dates, with no way to
     fix it: the card they would need to click isn't on screen, and the one that
     is already looks like the only choice. They'd book a shipping order for a
     day we don't ship without ever doing anything wrong.

     mode-switch.js pins attributes["Order Fulfillment Type"] before PickEasy
     loads, which normally prevents this. This is the recovery for when that
     doesn't win: if the visible card isn't the active one, click it.

     A click is what a shopper would do, and it makes PickEasy load that method's
     slots properly. An earlier version of this clicked on a timer forever
     because it had no way to tell whether the click had worked — it was looking
     for a radio input and an `active` class on the outer cell, neither of which
     exists. PickEasy's real marker is `ft-options-active` on the inner
     .ft-options div (confirmed on the live cart), so this now stops the instant
     it succeeds, and caps attempts so a card that refuses to activate can never
     produce a loop. */
  const SHIPPING_CARD_ID = 'standard-shipping-option-div';

  /* Wait for PickEasy to settle before clicking anything.

     The previous theme clicked the shipping card exactly once, 2200ms after
     load, guarded by a one-shot flag (snippets/popup-delivery-options.liquid).
     That delay wasn't arbitrary padding — PickEasy renders its cards well
     before it finishes wiring handlers and loading slots, so a click that lands
     in that window changes the highlight without the slot data following. It
     shows Standard Shipping selected while the calendar still holds Local
     Delivery's dates, which is exactly the symptom we've been chasing.

     So: give it the same grace period, measured from when the card first
     appears rather than from page load, and click at most once per episode. */
  const SETTLE_MS = 2200;
  let cardFirstSeenAt = 0;
  let clickedThisEpisode = false;

  /* Drop PickEasy's per-month slot cache once shipping is confirmed active.

     PickEasy fetches a month's slots once and keeps them (getMonthWiseSlots /
     resetMonthWiseSlots). During load it is still on its Local Delivery default,
     so the current month can be cached with delivery's dates. The visible
     calendar then corrects itself when shipping becomes active — but page
     forward a month and back, and July is served from that stale cache, showing
     local's days on a nationwide order. Reported exactly that way: correct on
     load, wrong after a there-and-back.

     Clearing it means any month fetched under the wrong method is discarded and
     re-fetched on demand, with shipping selected.

     Only resetMonthWiseSlots() is called. showShippingOrderSlots() — the other
     candidate — throws TypeError in handleDateAndTimeAttributeChange on this
     store, and calling it on a timer previously broke month navigation
     outright. This one was verified by hand in the console ("reset ok").

     Once per picker, only after the settle window, only while shipping is
     active, so it cannot clear a date the shopper has already chosen. Undocumented
     API, so feature-detected and wrapped, and never retried if it throws. */
  let shippingActiveSince = 0;
  let monthCacheDropped = false;

  function dropStaleMonthCache() {
    if (monthCacheDropped) return;
    if (!shippingActiveSince) {
      shippingActiveSince = Date.now();
      return;
    }
    if (Date.now() - shippingActiveSince < SETTLE_MS) return;

    const reset = typeof window.resetMonthWiseSlots === 'function' ? window.resetMonthWiseSlots : null;
    monthCacheDropped = true; /* set first: a throw must not retry */
    if (!reset) return;
    try {
      reset();
    } catch (e) {
      console.warn('[krudo] resetMonthWiseSlots failed', e);
    }
  }

  function ensureVisibleMethodSelected() {
    if (document.body.dataset.shoppingMode !== 'nationwide') return;

    /* Every instance, not just the first.

       On the cart page PickEasy renders TWICE — once into the page form and once
       into the cart drawer (which the drawer CSS hides but leaves in the DOM).
       Both are live and they share their state on `window`: selectedSlotOption,
       availableSlots, the month cache. Measured on the live cart, they disagree —
       the page copy had Standard Shipping active while the hidden drawer copy
       still had Local Delivery active, so whichever ran last decided what the
       shared globals said, and the calendar followed that.

       document.getElementById returns only the first match for a duplicated id,
       which is the page copy, so the drawer copy was never corrected. Select all
       of them. */
    const shippingCards = document.querySelectorAll('#' + SHIPPING_CARD_ID + ', [id="' + SHIPPING_CARD_ID + '"]');
    const shipping = shippingCards[0];
    if (!shipping) {
      /* Picker gone (cart re-render) — reset the whole episode. A fresh picker
         gets a fresh settle window, a fresh click, and another chance to drop a
         stale month cache. Resetting clickedThisEpisode here is what makes a
         re-render behave like the previous theme's page reload, which re-ran the
         hide-and-click sequence from scratch every time the cart changed. */
      cardFirstSeenAt = 0;
      clickedThisEpisode = false;
      shippingActiveSince = 0;
      monthCacheDropped = false;
      return;
    }

    if (!cardFirstSeenAt) {
      cardFirstSeenAt = Date.now();
      return;
    }
    if (Date.now() - cardFirstSeenAt < SETTLE_MS) return;

    /* Click once per episode, WITHOUT checking ft-options-active first.

       That check used to short-circuit this, and it was wrong. Pinning the cart
       attribute makes PickEasy paint the shipping card as active, so the guard
       always saw "already correct" and the click never fired at all — meaning
       PickEasy's own selection handler never ran. That handler is what sets its
       internal method and fetches slots for it, which is why the card could read
       active, selectedSlotOption could read "shipping", and availableSlots would
       still come back full of Local Delivery entries.

       The previous theme clicked unconditionally on every page load, gated only
       on being in nationwide mode, and its calendar was right. Do the same. */
    if (!clickedThisEpisode) {
      clickedThisEpisode = true;
      /* Click every instance so no hidden copy is left on Local Delivery
         writing the shared globals back to delivery. */
      shippingCards.forEach((card) => card.click());
      return; /* let the clicks settle before touching the slot cache */
    }

    dropStaleMonthCache();
  }

  /* ---------- Checkout gating ---------- */

  function cartHasItems() {
    /* The drawer hides the body content when empty and renders
       `.cart-drawer__empty` instead. The cart page renders
       `.cart__empty`. Use these as the empty markers. */
    if (document.querySelector('cart-drawer .cart-drawer__empty')) return false;
    if (document.querySelector('.cart__empty')) return false;
    /* Anything else: assume items present. */
    return !!document.querySelector('cart-drawer .cart-item, cart-items .cart-item, .cart-item');
  }

  /* Single gate: a date/time must be picked. The fulfillment-option /
     pickup-location checks have been stripped per spec — both delivery
     and pickup require a date/time, so date/time alone is the gate. */
  function hasDateTime() {
    /* The .neo-input mirrors the <datetime-slot-picker> selected value
       once the user has chosen BOTH a date and a time. Opening the
       calendar dropdown does not write to the input — only the final
       selection does — so this is the reliable signal.
       Skip values that equal the placeholder, in case PickEasy ever
       pre-fills the value with the prompt string. */
    const inputs = document.querySelectorAll(
      '#order-slot-pickers input[type="text"], #order-slot-pickers .neo-input'
    );
    for (const input of inputs) {
      const value = (input.value || '').trim();
      if (!value) continue;
      const placeholder = (input.getAttribute('placeholder') || '').trim();
      if (placeholder && value === placeholder) continue;
      return true;
    }
    return false;
  }

  function isComplete() {
    if (!cartHasItems()) return true; /* No items — nothing to gate. */
    return hasDateTime();
  }

  function checkoutButtons() {
    return document.querySelectorAll(
      'cart-drawer a[href="/checkout"], cart-drawer button[name="checkout"], cart-items a[href="/checkout"], cart-items button[name="checkout"], main-cart a[href="/checkout"], main-cart button[name="checkout"], .cart-drawer__action-buttons a[href="/checkout"], .cart-drawer__action-buttons button[name="checkout"], #main-cart-footer button[name="checkout"]'
    );
  }

  function setDisabled(btn, disabled) {
    if (disabled) {
      btn.classList.add('is-disabled');
      btn.setAttribute('aria-disabled', 'true');
      btn.dataset.krudoCheckoutBlocked = '1';
      btn.style.opacity = '0.5';
      btn.style.cursor = 'not-allowed';
    } else {
      btn.classList.remove('is-disabled');
      btn.removeAttribute('aria-disabled');
      delete btn.dataset.krudoCheckoutBlocked;
      btn.style.opacity = '';
      btn.style.cursor = '';
    }
  }

  function syncCheckoutButtons() {
    const complete = isComplete();
    checkoutButtons().forEach((btn) => setDisabled(btn, !complete));
  }

  /* Block clicks at the capture phase so the navigation/submit never fires. */
  document.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target.closest('a, button') : null;
      if (!target) return;
      const isCheckout =
        (target.tagName === 'A' && target.getAttribute('href') === '/checkout') ||
        (target.tagName === 'BUTTON' && target.getAttribute('name') === 'checkout');
      if (!isCheckout) return;
      if (isComplete()) return;
      event.preventDefault();
      event.stopPropagation();
      const container =
        target.closest('cart-drawer, cart-items, main-cart, .cart, #cart') ||
        target.parentElement;
      flashMessage(container, REQUIRED_MSG);
    },
    true
  );

  let messageEl = null;
  let messageTimer = null;
  function flashMessage(container, text) {
    if (!container) return;
    if (!messageEl) {
      messageEl = document.createElement('div');
      messageEl.className = 'krudo-checkout-warning';
      messageEl.setAttribute('role', 'alert');
      messageEl.style.cssText = [
        'background: #FBF4E6',
        'color: #420F12',
        'border: 1px solid #F04E23',
        'border-radius: 0.8rem',
        'padding: 1rem 1.2rem',
        'margin: 1rem 0 0',
        'font-family: var(--font-body-family, inherit)',
        'font-size: 1.4rem',
        'line-height: 1.4',
        'text-align: center',
      ].join(';');
    }
    messageEl.textContent = text;
    const anchor =
      container.querySelector('.cart-drawer__action-buttons') ||
      container.querySelector('#main-cart-footer') ||
      container.querySelector('.cart__footer-actions') ||
      container.querySelector('.cart__ctas');
    if (anchor && anchor.parentNode) {
      anchor.parentNode.insertBefore(messageEl, anchor.nextSibling);
    } else {
      container.appendChild(messageEl);
    }
    clearTimeout(messageTimer);
    messageTimer = setTimeout(() => {
      if (messageEl && messageEl.parentNode) messageEl.parentNode.removeChild(messageEl);
    }, 4000);
  }

  /* ---------- Wiring ---------- */

  function nudgePickEasy() {
    /* When the cache is empty (e.g. user just went empty→full) and
       PickEasy didn't re-inject on its own, dispatch the events it
       commonly listens for. Cheap and no-ops if PickEasy ignores them. */
    ['cart:refresh', 'cart:updated', 'pickeasy:reload'].forEach((name) => {
      try { document.dispatchEvent(new CustomEvent(name, { bubbles: true })); } catch (e) { /* noop */ }
    });
    if (window.PickEasy && typeof window.PickEasy.reload === 'function') {
      try { window.PickEasy.reload(); } catch (e) { /* noop */ }
    }
    if (window.pickeasy && typeof window.pickeasy.reload === 'function') {
      try { window.pickeasy.reload(); } catch (e) { /* noop */ }
    }
  }

  let pendingRaf = 0;
  function schedule() {
    if (pendingRaf) return;
    pendingRaf = requestAnimationFrame(() => {
      pendingRaf = 0;
      /* If the drawer (or main cart) was just re-rendered, immediately
         re-attach the picker. Capture again afterward, in case PickEasy
         did inject a fresh one. */
      restoreAll();
      captureAll();
      /* Empty→full transition: cache was cleared, restore did nothing,
         and PickEasy may not have re-injected. Soft nudge. */
      if (cartHasItems() && !document.querySelector('#order-slots')) {
        nudgePickEasy();
      }
      ensureVisibleMethodSelected();
      syncCheckoutButtons();
    });
  }

  function observeRoot(root) {
    if (!root) return;
    new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.addedNodes.length || m.removedNodes.length) {
          schedule();
          return;
        }
      }
    }).observe(root, { childList: true, subtree: true });
  }

  /* User interactions with the picker should trigger a re-sync of the
     checkout button (selected option / picked time changes complete state). */
  document.addEventListener(
    'change',
    (event) => {
      if (event.target instanceof Element && event.target.closest('#order-slots, #order-slot-pickers, #ft-options-div')) {
        syncCheckoutButtons();
      }
    },
    true
  );
  document.addEventListener(
    'click',
    (event) => {
      if (event.target instanceof Element && event.target.closest('#ft-options-div')) {
        /* Active class toggle happens after click — let it settle. */
        setTimeout(syncCheckoutButtons, 0);
      }
    },
    true
  );

  /* Programmatic value polling. PickEasy's <datetime-slot-picker> web
     component writes the picked date/time into .neo-input.value directly,
     usually without firing a `change` event — so neither the listener
     above nor the childList MutationObserver picks it up. Sync every
     200ms unconditionally so the visual stays aligned with isComplete()
     even when nothing else nudges us. */
  setInterval(() => {
    if (!document.querySelector('#order-slots, #ft-options-div')) return;
    ensureVisibleMethodSelected();
    syncCheckoutButtons();
  }, 200);

  /* Also sync on any input inside the picker (PickEasy occasionally
     does fire input on the .neo-input). */
  document.addEventListener(
    'input',
    (event) => {
      if (event.target instanceof Element && event.target.closest('#order-slots, #order-slot-pickers')) {
        syncCheckoutButtons();
      }
    },
    true
  );

  /* On click of any checkout button, refresh visual state first so the
     disabled styling never lags behind isComplete(). */
  document.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target.closest('a, button') : null;
      if (!target) return;
      const isCheckout =
        (target.tagName === 'A' && target.getAttribute('href') === '/checkout') ||
        (target.tagName === 'BUTTON' && target.getAttribute('name') === 'checkout');
      if (isCheckout) syncCheckoutButtons();
    },
    true
  );

  function start() {
    captureAll();
    syncCheckoutButtons();

    /* Observe both possible roots. The cart drawer body re-renders on
       every line change; the main cart section re-renders on the cart
       page. Re-observe lazily if the elements appear later. */
    const drawerBody = document.getElementById('CartDrawer-Body');
    if (drawerBody) observeRoot(drawerBody);

    const mainCart = document.getElementById('main-cart-items');
    if (mainCart) observeRoot(mainCart);

    /* If those weren't present at load time, watch body for them to appear. */
    new MutationObserver(() => {
      if (!observeRoot._drawer) {
        const dr = document.getElementById('CartDrawer-Body');
        if (dr) { observeRoot(dr); observeRoot._drawer = true; }
      }
      if (!observeRoot._main) {
        const mc = document.getElementById('main-cart-items');
        if (mc) { observeRoot(mc); observeRoot._main = true; }
      }
    }).observe(document.body, { childList: true, subtree: false });

    observeRoot._drawer = !!drawerBody;
    observeRoot._main = !!mainCart;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
